import React, { useContext, useMemo, useState } from 'react';
import proptypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { QaPageLinks } from '@thd-olt-component-react/search-page-links';
import { triggerAnalytics } from '../../Analytics';
import QAContext from '../../context/QAContext';
import {
  DEFAULT_NUMBER_OF_PAGES,
  QUESTION_DISPLAY_PER_PAGE,
  TOTAL_RESULTS_LIMIT,
} from '../../constants';
import './Pager.scss';

const { number } = proptypes;

export const Pager = ({ seoTotalResults, seoPageNumber }) => {
  const {
    currentPage, dispatch, TotalResults, itemId, channel
  } = useContext(QAContext);

  const isMobile = channel === 'mobile';

  const results = TotalResults || seoTotalResults;

  // Maintains a fallback for seoPageNumber that's updated in the change handler
  const [pagerNumber, setPagerNumber] = useState(currentPage);
  const pageNumberIncludingJsOff = typeof window === 'undefined' ? seoPageNumber : pagerNumber;

  const totalPages = useMemo(() => {
    if (!results) return DEFAULT_NUMBER_OF_PAGES;
    if (results >= TOTAL_RESULTS_LIMIT) return Math.floor(TOTAL_RESULTS_LIMIT / QUESTION_DISPLAY_PER_PAGE);
    return Math.ceil(results / QUESTION_DISPLAY_PER_PAGE);
  }, [results]);

  const scrollToQASection = () => {
    const el = document.getElementById('questions_answers_accordion_title');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleChange = (event, value) => {
    event.preventDefault();
    setPagerNumber(value);

    dispatch({ action: 'SET_CURRENT_PAGE', value });

    const newStartIndex = value === DEFAULT_NUMBER_OF_PAGES
      ? DEFAULT_NUMBER_OF_PAGES
      : QUESTION_DISPLAY_PER_PAGE * (value - DEFAULT_NUMBER_OF_PAGES) + DEFAULT_NUMBER_OF_PAGES;

    dispatch({ action: 'SET_START_INDEX', value: newStartIndex });

    const payload = { component: 'pagination' };
    triggerAnalytics(payload);
    scrollToQASection();
  };


  return (
    <QaPageLinks
      itemId={itemId}
      paginationProps={{
        count: totalPages,
        page: pageNumberIncludingJsOff,
        onChange: handleChange,
        fullWidth: true,
        'data-testid': isMobile ? 'pagination-compact' : 'pagination',
        disable: totalPages === 1
      }}
    />
  );
};

Pager.displayName = 'Pager';

Pager.dataModel = extend({}, QaPageLinks);

Pager.propTypes = {
  seoTotalResults: number,
  seoPageNumber: number
};

Pager.defaultProps = {
  seoTotalResults: null,
  seoPageNumber: null,
};
